import React from 'react';
import update from 'immutability-helper';
import {connect} from "react-redux";
import Select from "./Select"
import ReactSelect from 'react-select';
import AsyncSelect from 'react-select/async';
import Text from "./text"
import {findFieldById, actionIcons} from '../../schema'
import ReactResponsiveSelect from 'react-responsive-select';
import style from './conditionalLogic.scss'
import style1 from './ReactResponsiveSelect.css'
import { array } from 'prop-types';

// Language

import fetchWP from '../../utils/fetchWP';

let searchWP = new fetchWP({
    restURL: window.awcfe_object.root,
    restNonce: window.awcfe_object.api_nonce,
});
const loadProdOptions = (inputValue, callback) => {
    searchWP.get('productsearch/?search=' + inputValue ).then(
        (json) => {
            callback(json);
        }
    )
};

const caretIcon = (
    <svg className="caret-icon" x="0px" y="0px" width="11.848px" height="6.338px" viewBox="351.584 2118.292 11.848 6.338">
        <g><path d="M363.311,2118.414c-0.164-0.163-0.429-0.163-0.592,0l-5.205,5.216l-5.215-5.216c-0.163-0.163-0.429-0.163-0.592,0s-0.163,0.429,0,0.592l5.501,5.501c0.082,0.082,0.184,0.123,0.296,0.123c0.103,0,0.215-0.041,0.296-0.123l5.501-5.501C363.474,2118.843,363.474,2118.577,363.311,2118.414L363.311,2118.414z"/></g>
    </svg>
);

const multiSelectOptionMarkup = (text) => (
    <div>
    <span className="checkbox">
      <svg className="checkbox-icon" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 488.878 488.878">
        <g><polygon points="143.294,340.058 50.837,247.602 0,298.439 122.009,420.447 122.149,420.306 144.423,442.58 488.878,98.123 437.055,46.298 "/></g>
      </svg>
    </span>
        <span> {text}</span>
    </div>
);

const emptyRow = {
    // "operator": 'AND',
    "operator": false,
    "rules": {
        "cl_field": "",
        "cl_relation": "",
        "cl_val": ""
    }
};
const emptyGroup = {
    "operator": false,
    "rules": [emptyRow]
}

const user_roles = [...Object.keys(window.awcfe_object.user_roles).map((key) => {
    return {value: key, text: window.awcfe_object.user_roles[key]};
})];

const product_list = [...Object.keys(window.awcfe_object.product_list).map((key) => {
    return {value: window.awcfe_object.product_list[key]['id'], text: window.awcfe_object.product_list[key]['name']  };
})];

const productList = [...Object.keys(window.awcfe_object.product_list).map((key) => {
    return {value: window.awcfe_object.product_list[key]['id'], text: window.awcfe_object.product_list[key]['name']  };
})];

const category_list = [...Object.keys(window.awcfe_object.category_list).map((key) => {
    return {value: window.awcfe_object.category_list[key]['id'], text: window.awcfe_object.category_list[key]['name']};
})];

const day_list = [
  {label: 'Sunday', value: 'sunday'},
  {label: 'Monday', value: 'monday'},
  {label: 'Tuesday', value: 'tuesday'},
  {label: 'Wednesday', value: 'wednesday'},
  {label: 'Thursday', value: 'thursday'},
  {label: 'Friday', value: 'friday'},
  {label: 'Saturday', value: 'saturday'},
];

/*
var conditions = [
    {label: 'Select', 'value': '0'},
    {label: 'Is', 'value': 'is', type: ['!product_ids']},
    {label: 'Is not', 'value': 'is_not', type: ['!product_ids']},

    {label: 'Is In', 'value': 'is_in', type: ['product_ids']},

    {label: 'Is Not In', 'value': 'is_not_in', type: ['product_ids']},

    {label: 'Is empty', 'value': 'is_empty', type: ['!stock_status', '!product_ids']},
    {label: 'Is not empty', 'value': 'is_not_empty', type: ['!stock_status', '!product_ids']},
    { label: 'Is greater than', 'value': 'is_greater', type: ['!date', '!time', '!datetime-local', '!stock_status', '!product_ids'] },
    { label: 'Is less than', 'value': 'is_lessthan', type: ['!date', '!time', '!datetime-local', '!stock_status', '!product_ids'] },
    { label: 'Is greater or equal', 'value': 'is_greater_or_equal', type: ['!date', '!time', '!datetime-local', '!stock_status', '!product_ids'] },
    { label: 'Is less than or equal', 'value': 'is_lessthan_or_equal', type: ['!date', '!time', '!datetime-local', '!stock_status', '!product_ids'] },
    {label: 'Text Contains ', 'value': 'contains', type: ['!stock_status', '!product_ids']},
    {label: 'Text does not contains ', 'value': 'not_contains', type: ['!stock_status', '!product_ids']},
    {label: 'Text starts with', 'value': 'starts_with', type: ['!stock_status', '!product_ids']},
    {label: 'Text ends with', 'value': 'ends_with', type: ['!stock_status', '!product_ids']},
    {label: 'Date is', 'value': 'date_is', type: ['datepicker']},
    {label: 'Date is before', 'value': 'date_is_before', type: ['date', 'datetime-local']},
    {label: 'Date is after', 'value': 'date_is_after', type: ['date', 'datetime-local' ]},
    {label: 'Time is ', 'value': 'time_is', type: ['time']},
    {label: 'Time is before', 'value': 'time_is_before', type: ['time']},
    {label: 'Time is after', 'value': 'time_is_after', type: ['time']}
];
*/


const conditions = [
    {label: 'Select', 'value': '0'},
    {label: 'Is', 'value': 'is' },
    {label: 'Is not', 'value': 'is_not' },
    {label: 'Is empty', 'value': 'is_empty'},
    {label: 'Is not empty', 'value': 'is_not_empty'},
    // {label: 'Text Contains ', 'value': 'contains'},
    // {label: 'Text does not contains ', 'value': 'not_contains'},
];
const conditions_00 = [
    {label: 'Text Contains ', 'value': 'contains'},
    {label: 'Text does not contains ', 'value': 'not_contains'},
];
const conditions_p = [
    {label: 'Select', 'value': '0'},
    {label: 'Is In', 'value': 'is_in'},
    {label: 'Is Not In', 'value': 'is_not_in'},
];
const conditions_d = [
    {label: 'Select', 'value': '0'},
    {label: 'Is Selected', 'value': 'is_select'},
    {label: 'Is Not Selected', 'value': 'is_not_select'},
];
const conditions_0 = [
    {label: 'Select', 'value': '0'},
    {label: 'Is', 'value': 'is'},
    {label: 'Is not', 'value': 'is_not'},
];
const conditions_1 = [
    {label: 'Date is', 'value': 'date_is'},
    {label: 'Date is before', 'value': 'date_is_before'},
    {label: 'Date is after', 'value': 'date_is_after'},
    {label: 'Day is', 'value': 'day_is'},
    {label: 'Day is not', 'value': 'day_is_not'},
];
const conditions_2 = [
    {label: 'Time is ', 'value': 'time_is' },
    {label: 'Time is before', 'value': 'time_is_before' },
    {label: 'Time is after', 'value': 'time_is_after' }
];
const conditions_3 = [
    { label: 'Is greater than', 'value': 'is_greater' },
    { label: 'Is less than', 'value': 'is_lessthan' },
    { label: 'Is greater or equal', 'value': 'is_greater_or_equal' },
    { label: 'Is less than or equal', 'value': 'is_lessthan_or_equal' },
];
const conditions_4 = [
    {label: 'Text Contains ', 'value': 'contains' },
    {label: 'Text does not contains ', 'value': 'not_contains' },
    {label: 'Text starts with', 'value': 'starts_with' },
    {label: 'Text ends with', 'value': 'ends_with' },
];
const conditions_5 = [
    {label: 'Product ', 'value': 'is_cart_product' },
    {label: 'Category ', 'value': 'is_cart_category' },
];

const findFieldByKey = (elementId, fields) => {

    let col = false;
    // row = fields.
    const row = fields.findIndex(e => {
        col = e.findIndex(f => {
            if( f.bindingKey === undefined ){
                return f.name + "_field" === elementId
            } else {
                return f.bindingKey + "_field" === elementId
            }
        });
        if (col !== -1) {
            return true;
        }
        return false;
    });

    return {field: (fields.length && row !== -1) ? fields[row][col] : false, row, col}

}

const getFieldById = (fieldId, ReduxFields) => {

    for (let i = 0; i < Object.keys(ReduxFields).length; i++) {

        let field = findFieldById(fieldId, ReduxFields[Object.keys(ReduxFields)[i]].fields);
        let fieldKey = findFieldByKey(fieldId, ReduxFields[Object.keys(ReduxFields)[i]].fields);
        if (field.field !== false) {
            return field.field;
        } else if (fieldKey.field !== false) {
            return fieldKey.field;
        }
    }
    return false;

}


class RenderConditionalLogic extends React.Component {

    getOptionByValue = (value, fieldList) => {

        const group = fieldList.find(e => {
            return e.options.find(f => {
                return f.value === value;
            })
        });
        if (!group || group === false) {
            return false;
        }
        return group.options.find(f => {
            return f.value === value;
        })

    }

    relationsForField = fieldId => {

        const {ReduxFields} = this.props;
        var fieldType = getFieldById(fieldId, ReduxFields).type;

        if(fieldId === 'user_role'){
            fieldType = 'user_role';
        } else if(fieldId === 'cart_subtotal' ){
            fieldType = 'cart_subtotal';
        } else if( fieldId === 'cart_total'){
            fieldType = 'cart_total';
        } else if( fieldId === 'cart_weight'){
            fieldType = 'cart_weight';
        } else if( fieldId === 'cart_contains'){
            fieldType = 'cart_contains';
        } else if( fieldId === 'cart_not_contains'){
            fieldType = 'cart_not_contains';
        } else if( fieldId === 'cart_only_contains'){
            fieldType = 'cart_only_contains';
        } else if( fieldId === 'cart_product'){
            fieldType = 'cart_product';
        } else if( fieldId === 'cart_variation'){
            fieldType = 'cart_variation';
        } else if( fieldId === 'cart_category'){
            fieldType = 'cart_category';
        } else if( fieldId === 'shipping_class'){
            fieldType = 'shipping_class';
        } else if( fieldId === 'payment_method'){
            fieldType = 'payment_method';
        } else if( fieldId === 'checkout_deposit'){
            fieldType = 'checkout_deposit';
        } else if( fieldId === 'shipping_method'){
            fieldType = 'shipping_method';
        }

        if( fieldType === 'datepicker' || fieldType === 'datetimepicker' ) {
            var relations = conditions.concat(conditions_1);

        } else if( fieldType === 'timepicker') {
            var relations = conditions.concat(conditions_2);

        }  else if( fieldType === 'monthpicker') {
            var relations = conditions;

        }
        else if( fieldType === 'weekpicker') {
            var relations = conditions;

        }
        else if( fieldType === 'file' || fieldType === 'url' ) {
            var relations = conditions;
            // var relations = conditions.concat(conditions_3);

        } else if( fieldType === 'textarea') {
            var relations = conditions.concat(conditions_4);

        } else if( fieldType === 'text' ) {
            var relations = conditions.concat(conditions_00);

        } else if( fieldType === 'select' || fieldType === 'multiselect' || fieldType === 'colorpicker'  ) {
            var relations = conditions;

        } else if( fieldType === 'radio' || fieldType === 'checkboxGroup' || fieldType === 'imageGroup' || fieldType === 'colorGroup' ) {
            var relations = conditions;

        } else if( fieldType === 'checkbox' || fieldType === 'toggleSwitch' ) {
            var relations = conditions_0;
        } else if( fieldType === 'country' || fieldType === 'state' ) {
            var relations = conditions_0;

        } else if( fieldType === 'cart_subtotal' || fieldType === 'cart_total' || fieldType === 'cart_weight' ) {
            var relations = conditions.concat(conditions_3);

        } else if( fieldType === 'cart_contains' || fieldType === 'cart_not_contains' || fieldType === 'cart_only_contains') {
            var relations = conditions_5;

        } else if( fieldType === 'cart_product' || fieldType === 'cart_category' || fieldType === 'cart_variation' || fieldType === 'payment_method' || fieldType === 'shipping_method' || fieldType === 'shipping_class' ) {
            var relations = conditions_p;

        } else if( fieldType === 'checkout_deposit' ) {
            var relations = conditions_d;

        } else if( fieldType === 'user_role' ) {
            var relations = conditions_p;

        } else {
            //var relations = conditions;

            var relations = [
                {label: 'Select', 'value': '0'},
                {label: 'Is', 'value': 'is' },
                {label: 'Is not', 'value': 'is_not' },
                {label: 'Is In', 'value': 'is_in' },
                {label: 'Is Not In', 'value': 'is_not_in' },
                {label: 'Is empty', 'value': 'is_empty' },
                {label: 'Is not empty', 'value': 'is_not_empty' },
                { label: 'Is greater than', 'value': 'is_greater' },
                { label: 'Is less than', 'value': 'is_lessthan' },
                { label: 'Is greater or equal', 'value': 'is_greater_or_equal' },
                { label: 'Is less than or equal', 'value': 'is_lessthan_or_equal' },
                {label: 'Text Contains ', 'value': 'contains'},
                {label: 'Text does not contains ', 'value': 'not_contains'},
                {label: 'Text starts with', 'value': 'starts_with' },
                {label: 'Text ends with', 'value': 'ends_with' },
                {label: 'Date is', 'value': 'date_is' },
                {label: 'Date is before', 'value': 'date_is_before' },
                {label: 'Date is after', 'value': 'date_is_after' },
                {label: 'Time is ', 'value': 'time_is' },
                {label: 'Time is before', 'value': 'time_is_before' },
                {label: 'Time is after', 'value': 'time_is_after' },
                {label: 'Day is', 'value': 'day_is'},
                {label: 'Day is not', 'value': 'day_is_not'},
                {label: 'Is Selected', 'value': 'is_select'},
                {label: 'Is Not Selected', 'value': 'is_not_select'},
            ];


        }

        /*
            const relations = conditions.map(e => {
                const f = {label: e.label, value: e.value}
                if (!e.type) {
                    return f;
                }


                if (e.type.indexOf(`!${fieldType}`) !== -1) {
                    return {...f, isDisabled: true};
                }
                e.type = e.type.filter((g) => {
                    return !g.startsWith('!')
                })

                if (e.type.length === 0) {
                    return f;
                }
                if (e.type.indexOf(`!${fieldType}`) !== -1 || e.type.indexOf(`all`) !== -1) {
                    return f;
                }

                return {...f, isDisabled: true};

            });
        */

        return relations;
    }

    constructor(props) {
        super(props);
        const forms = [];
        const rules = [{
            "operator": false,
            "rules": [{
                "operator": false,
                "rules": {"cl_field": "custom_field", "cl_relation": "abc", "cl_val": "350gsm|650gsm"}
            }]
        }];

        this.state = {
            data: rules,
            type: props.type
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.rules !== this.props.rules) {
            this.setState({data: nextProps.rules});
        }
    }

    handleRemove(event, i, j) {

        const {field, item, handleChange} = this.props;
        const relations = field[item.item] ? field[item.item] : [emptyGroup];
        const updated = update(field, {relations: {[i]: {rules: {$splice: [[j, 1]]}}}});
        if (updated.relations[i].rules.length > 0 && typeof updated.relations[i].rules[updated.relations[i].rules.length - 1].operator !== "undefined") {
            handleChange(update(updated, {relations: {[i]: {rules: {[updated.relations[i].rules.length - 1]: {operator: {$set: false}}}}}}))
        } else {
            handleChange(updated);
        }

    }

    handleGroupRemove(event, i) {


        const {field, item, handleChange, } = this.props;
        const relations = field[item.item] ? field[item.item] : [emptyGroup];
        handleChange(update(field, {relations: {$splice: [[i, 1]]}}));
    }


    handleGroupAdd() {

        const {field, item, handleChange} = this.props;
        let relations = false;

        if (field[item.item] && field[item.item].length > 0) {
            relations = field[item.item];
            handleChange(
                update(update(field, {relations: {[relations.length - 1]: {operator: {$set: 'and'}}}}),
                    {relations: {$push: [emptyGroup]}})
            )
        } else {
            handleChange(update(field, {relations: {$set: [emptyGroup]}}))
        }


    }

    // handleValueChange(event, i, j) {
    //     const val = event.target.value;
    //     //    let data = update(this.state.data, { [i]: { rules: { [j]: { rule: { value: { $set: val } } } } }} );
    //     this.setState((prevState) => ({
    //         data: update(this.state.data, {[i]: {rules: {[j]: {rule: {value: {$set: val}}}}}})
    //     }), () => {
    //         this.props.onChange(this.state.data)
    //     })
    // }
    //
    // handleRelationChange(value, i, j = false) {
    //     const val = value.value;

    //     if (j === false) {
    //         this.setState((prevState) => ({
    //             data: update(this.state.data, {[i]: {operator: {$set: val}}})
    //         }), () => {
    //             this.props.onChange(this.state.data)
    //         })
    //     } else {
    //         this.setState((prevState) => ({
    //             data: update(this.state.data, {[i]: {rules: {[j]: {operator: {$set: val}}}}})
    //         }), () => {
    //             this.props.onChange(this.state.data)
    //         })
    //     }
    // }
    //
    // handleCatChange(value, i, j) {
    //     if (value) {
    //         const options = value.options.map(e => {
    //             return e.value;
    //         });

    //         this.setState((prevState) => ({
    //             data: update(this.state.data, {[i]: {rules: {[j]: {rule: {value: {$set: options}}}}}})
    //         }), () => {
    //             this.props.onChange(this.state.data)
    //         })
    //     }
    // }

    handleConditionChange(value, i, j) {
        const item = null;

        if (value) {
            const sub = '';
            // if (item.sub) {
            //     sub = item.sub;
            // }
            // this.setState((prevState) => ({
            //     ...prevState, value: item[0].conditions
            // }))
            this.setState((prevState) => ({
                data: update(this.state.data, {[i]: {rules: {[j]: {rule: {condition: {$set: value.value}}}}}})
            }), () => {
                this.props.onChange(this.state.data)
            })
        }
    }

    handleRelationChange(newvalue, i, j = false) {
        const {value} = newvalue;
        const {field, item, handleChange} = this.props;

        const relations = field[item.item] ? field[item.item] : [emptyGroup];
        if (j === false) {
            handleChange(update(field, {relations: {[i]: {operator: {$set: value}}}}))
        } else {
            handleChange(update(field, {relations: {[i]: {rules: {[j]: {operator: {$set: value}}}}}}))
        }
    }

    handleChange(newvalue, event, i = false, j = false) {
        // this.state.data[i].rules[j].value =  event.target.value;

        const {value} = newvalue;
        const {field, item, handleChange} = this.props;

        if (event.name === 'cl_rule') {
            handleChange(update(field, {cl_rule: {$set: value}}));
            return;
        }
        const relations = field[item.item] ? field[item.item] : [emptyGroup];
        handleChange(update(field, {relations: {[i]: {rules: {[j]: {rules: {[event.name]: {$set: value}}}}}}}));

    }

    handleAdd(event, i) {
        const {field, item, handleChange} = this.props;
        const relations = field[item.item] ? field[item.item] : [emptyGroup];
        if (relations[i].rules.length > 0) {
            handleChange(
                update(
                    update(
                        field,
                        {relations: {[i]: {rules: {[relations[i].rules.length - 1]: {operator: {$set: 'and'}}}}}}
                    ),
                    {relations: {[i]: {rules: {$push: [emptyRow]}}}}
                ))
        } else {
            handleChange(
                update(
                    field,
                    {relations: {[i]: {rules: {$push: [emptyRow]}}}}
                ))
        }

    }

    render() {
        let render;
        const {ReduxFields, isEnabled, isReadOnly } = this.props;

        const Fields = {
            /* "product": {
                "extra": {"name": "Product specific" },
                "fields": [
                    [{"label": "Product", "elementId": "cart_product", "active": true }],
                ]
            },
            "category": {
                "extra": {"name": "Category specific" },
                "fields": [
                    [{"label": "Category", "elementId": "cart_category", "active": true }],
                ]
            }, */
            "rules": {
                "extra": {"name": "Cart specific", "custom": true },
                "fields": [
                    // [{"label": "Cart contains", "elementId": "cart_contains", "active": true }],
                    // [{"label": "Cart not contains", "elementId": "cart_not_contains", "active": true }],
                    // [{"label": "Cart only contains", "elementId": "cart_only_contains", "active": true }],
                    [{"label": "Product", "elementId": "cart_product", "active": true }],
                    [{"label": "Product variation", "elementId": "cart_variation", "active": true }],
                    [{"label": "Category", "elementId": "cart_category", "active": true }],
                    [{"label": "Cart subtotal", "elementId": "cart_subtotal", "active": true }],
                    [{"label": "Cart total", "elementId": "cart_total", "active": true }],
                    [{"label": "Payment method", "elementId": "payment_method", "active": true }],
                    [{"label": "Shipping method", "elementId": "shipping_method", "active": true }],
                    [{"label": "Shipping class", "elementId": "shipping_class", "active": true }],
                    [{"label": "Cart weight", "elementId": "cart_weight", "active": true }],
                    [{"label": "Checkout Deposit", "elementId": "checkout_deposit", "active": true }],
                    // [{"label": "Cart count", "elementId": "cart_count", "active": true }],
                ]
            },
            "user": {
                "extra": {"name": "Role specific", "custom": true },
                "fields": [
                    [{"label": "User Role", "elementId": "user_role", "active": true }],
                ]
                // "fields": [user_roles]
            }
        };
        var NewFields = {...Fields, ...ReduxFields };
        // var NewFields = {...ReduxFields };


        const fieldList = Object.keys(NewFields).map(e => {
            let options = [];
            let opts = [];
            NewFields[e].fields.forEach(f => {
                f.forEach(_f => {

                    if( _f.active === true && _f.type !== 'header' && _f.type !== 'paragraph' && _f.type !== 'htmlf' && _f.type !== 'placeselector' && _f.subtype !== 'hidden'){

                        // opts = {
                        //     'label': _f.label,
                        //     'value': _f.elementId
                        // };

                         // if( _f.custom === false ) {
                         if( NewFields[e].extra.custom === false ) {
                             if( _f.bindingKey === undefined ){
                                 opts = {
                                     'label': _f.label,
                                     'value': _f.name + "_field"
                                 };
                             } else {
                                 opts = {
                                     'label': _f.label,
                                     'value': _f.bindingKey + "_field"
                                 };
                             }
                        } else {
                            opts = {
                                'label': _f.label,
                                'value': _f.elementId
                            };
                        }

                        options.push(opts);
                    }
                })
                /*
                options = [...options, ...f.map(_f => {
                        return {
                            'label': _f.label,
                            'value': _f.elementId
                        };
                })]
                */
            });
            return {
                label: NewFields[e].extra.name,
                options: options
            }
        });

        // const conditions_set_1 = [
        //     {text: __('Equal to', 'aco-woo-dynamic-pricing'), value: 'equal_to', sub: {type: 'number'}},
        //     {text: __('Less than', 'aco-woo-dynamic-pricing'), value: 'less_than', sub: {type: 'number'}},
        //     {text: __('Less than or Equal', 'aco-woo-dynamic-pricing'), value: 'less_than_eq', sub: {type: 'number'}},
        //     {text: __('Greater than', 'aco-woo-dynamic-pricing'), value: 'greater_than', sub: {type: 'number'}},
        //     {
        //         text: __('Greater than or Equal', 'aco-woo-dynamic-pricing'),
        //         value: 'greater_than_eq',
        //         sub: {type: 'number'}
        //     }
        // ];
        //
        //
        // const rules_items = [
        //     {
        //         text: __('Select Item', 'aco-woo-dynamic-pricing'),
        //         value: '',
        //         conditions: []
        //     },
        //     {
        //         text: __('Product price', 'aco-woo-dynamic-pricing'),
        //         value: 'product_price',
        //         conditions: [...conditions_set_1],
        //     },
        //     {
        //         text: __('Cart total amount', 'aco-woo-dynamic-pricing'),
        //         value: 'cart_total_amount',
        //         conditions: [...conditions_set_1],
        //     }
        // ];
        //
        // if (this.state.type != 'cart_quantity') {
        //     rules_items.push({
        //         text: __('Cart total quantity', 'aco-woo-dynamic-pricing'),
        //         value: 'cart_items',
        //         conditions: [...conditions_set_1]
        //     }, {
        //         text: __('Cart items count', 'aco-woo-dynamic-pricing'),
        //         value: 'cart_product',
        //         conditions: [...conditions_set_1]
        //     });
        // }
        const {field, item} = this.props;
        let relations = false;
        if (isEnabled) {
            relations = field[item.item] ? field[item.item] : [emptyGroup];
        } else {
            relations = field[item.item] ? field[item.item] : this.handleGroupAdd();
        }

        if (relations && relations.length) {
            render = relations.map((e, i) => {
                const temp = [];
                if (e.rules.length) {
                    temp.push(e.rules.map((f, j) => {

                        if (f != null) {

                            let relation = '';
                            if (j < (e.rules.length - 1) && e.rules.length > 1) {
                                relation = (
                                    <Select
                                        className={style.operator}
                                        isReadOnly={isReadOnly}
                                        options={
                                            [
                                                {label: 'AND', value: 'and'},
                                                {label: 'OR', value: 'or'}
                                            ]
                                        }
                                        name="operator"
                                        value={[
                                            {label: 'AND', value: 'and'},
                                            {label: 'OR', value: 'or'}
                                        ].filter(_e => _e.value === f.operator)}
                                        onChange={(newvalue) => {
                                            this.handleRelationChange(newvalue, i, j)
                                        }}
                                    />
                                )
                            }

                            return (
                                <div className={style.relWrap}>

                                    <Select
                                        className={style.field}
                                        label="Items"
                                        isReadOnly={isReadOnly}
                                        options={fieldList}
                                        value={this.getOptionByValue(f.rules.cl_field, fieldList)}
                                        name="cl_field"
                                        onChange={(newvalue, event) => {
                                            this.handleChange(newvalue, event, i, j)
                                        }}
                                        placeholder
                                    />

                                    <Select
                                        className={style.relation}
                                        label="Relations"
                                        isReadOnly={isReadOnly}
                                        key={f.rules.cl_field}// re-render on f.cl_field change
                                        options={this.relationsForField(f.rules.cl_field)}
                                        value={this.relationsForField().find(tmp => tmp.value === f.rules.cl_relation)}
                                        name="cl_relation"
                                        onChange={(newvalue, event) => {
                                            this.handleChange(newvalue, event, i, j)
                                        }}
                                        placeholder
                                    />

                                    {
                                        f.rules.cl_relation && f.rules.cl_relation != 0 ?

                                            <ClValueField
                                                f={f}
                                                className={style.value}
                                                ReduxFields={ReduxFields}
                                                value={f.rules.cl_val}
                                                onChange={(newvalue, event) => {
                                                    this.handleChange(newvalue, {name: "cl_val"}, i, j)
                                                }}/>
                                        :
                                            null
                                    }
                                    {relation}

                                    <span
                                        className={style.remove}
                                        readOnly={isReadOnly}
                                        title={wp.i18n.__('Remove', 'aco-woo-dynamic-pricing')}
                                        onClick={(event) => {
                                            this.handleRemove(event, i, j);
                                        }}>
                                        <img src={actionIcons['trash'].icon} title={actionIcons['trash'].label}/>
                                    </span>
                                </div>
                            );

                            // return temp.reduce((a, b) => {a + b});
                        }
                    }))
                }

                let relation = '';
                if (i < (relations.length - 1) && relations.length > 1) {

                    relation = (
                        <div className={style.operatorwrapper} >
                        <Select
                            className={style.operator}
                            isReadOnly={isReadOnly}
                            options={
                                [
                                    {label: 'AND', value: 'and'},
                                    {label: 'OR', value: 'or'}
                                ]
                            }
                            value={[
                                {label: 'AND', value: 'and'},
                                {label: 'OR', value: 'or'}
                            ].filter(_e => _e.value === e.operator)}

                            onChange={(newvalue) => {
                                this.handleRelationChange(newvalue, i, false)
                            }}
                        />
                        </div>
                    )
                }

                return (<div className={style.groupWrap}>
                    {temp.length != 0 ? temp.reduce((a, b) => {
                        return a + b
                    }) : ''}
                    <div className={style.ruleAction}>
                        <button
                            readOnly={isReadOnly}

                            className={style.awdp_add}
                            title={wp.i18n.__('Add Condition', 'aco-woo-dynamic-pricing')}
                            onClick={(event) => {
                                this.handleAdd(event, i);
                            }}>Add Condition
                        </button>

                        <button
                            readOnly={isReadOnly}
                            className={style.awdp_removegroup}
                            onClick={(event) => {
                            this.handleGroupRemove(event, i);
                        }}> {wp.i18n.__('Remove Group')}
                        </button>
                    </div>

                    {relation}
                </div>);
            });
        }

        return (
            <div className={isEnabled ? style.readOnlyClass : ''}>
                <div>
                    <label className={style.select} ><strong>Logic Action</strong></label>
                    <div className={style.logicAction}>
                        <Select
                            className={style.select}
                            style={{width: '55px', display: "inline-block"}}
                            isReadOnly={isReadOnly}
                            options={
                                [{value: "show", label: "Show"}, {value: "hide", label: "Hide"}]
                            }
                            value={
                                [{value: "show", label: "Show"}, {
                                    value: "hide",
                                    label: "Hide"
                                }].filter(_e => _e.value === field.cl_rule)
                            }
                            onChange={(newvalue) => {
                                this.handleChange(newvalue, {name: "cl_rule"})
                            }}

                        />
                        <p style={{display: "inline-block"}}>field <strong>{field.label}</strong> if below conditions
                            are TRUE</p>
                    </div>

                </div>

                {render}

                <button
                    className={style.cl_add_group}
                    readOnly={isReadOnly}
                    onClick={(event) => {
                        this.handleGroupAdd(event);
                    }}> {wp.i18n.__('Add New Group')}
                </button>
            </div>
        );
    }
}

const ClValueField = props => {
    const {f, value, onChange, ReduxFields, className} = props; // f => field

    const cl_val_type = {
        field: {
            select: ['select', 'checkboxGroup', 'radio', 'multiselect', 'imageGroup', 'colorGroup'],
            date: ['datepicker'],
            datetime: ['datetimepicker'],
            month: ['monthpicker'],
            week: ['weekpicker'],
            time: ['timepicker'],
            text: ['text', 'colorpicker', 'numberfield', 'textarea', 'file', 'hidden', 'country','state', 'checkbox', 'toggleSwitch', 'url'],
            user_role: ['user_role'],
            cart_subtotal: ['cart_subtotal'],
            cart_total: ['cart_total'],
            cart_weight: ['cart_weight'],
            cart_contains: ['cart_contains'],
            cart_not_contains: ['cart_not_contains'],
            cart_only_contains: ['cart_only_contains'],
            cart_product: ['cart_product'],
            cart_variation: ['cart_variation'],
            cart_category: ['cart_category'],
            shipping_class: ['shipping_class'],
            payment_method: ['payment_method'],
            shipping_method: ['shipping_method'],
            checkout_deposit: ['checkout_deposit'],
        },
        relation: {
            text: ['is_greater', 'is_lessthan', 'is_greater_or_equal', 'is_lessthan_or_equal', 'contains', 'not_contains', 'starts_with', 'ends_with'],
            date: ['date_is', 'date_is_before', 'date_is_after','day_is', 'day_is_not'],
            time: ['time_is', 'time_is_before', 'time_is_after'],
            datetime: ['date_is', 'date_is_before', 'date_is_after','time_is', 'time_is_before', 'time_is_after'],
            month:['is', 'is_not'],
            week:['is', 'is_not'],
            user_role: ['is', 'is_not'],
            cart_subtotal: ['is', 'is_not'],
            cart_total: ['is', 'is_not'],
            cart_weight: ['is', 'is_not'],
            cart_product: ['is', 'is_not'],
            cart_variation: ['is', 'is_not'],
            payment_method: ['is', 'is_not'],
            checkout_deposit: ['is_select', 'is_not_select'],
            shipping_method: ['is', 'is_not'],
            cart_category: ['is', 'is_not'],
            shipping_class: ['is', 'is_not'],
            cart_contains: ['is_cart_product', 'is_cart_category'],
            cart_not_contains: ['is_cart_product', 'is_cart_category'],
            cart_only_contains: ['is_cart_product', 'is_cart_category'],
            nofield: ['is_empty', 'is_not_empty' ],
        }
    };

    const selectedField = getFieldById(f.rules.cl_field, ReduxFields);

    let valType = false;

    if (cl_val_type.relation.text.includes(f.rules.cl_relation)) {
        valType = 'text';
    } else if (cl_val_type.relation.nofield.includes(f.rules.cl_relation)) {
        valType = 'nofield';
    } else {

        if(f.rules.cl_field === 'user_role') {
            valType = 'user_role';
        } else if(f.rules.cl_field === 'cart_subtotal' || f.rules.cl_field === 'cart_total' || f.rules.cl_field === 'cart_weight'){
            valType = 'text';
        } else if(f.rules.cl_field === 'cart_variation' ){
            valType = 'text_variation';
        } else if(f.rules.cl_field === 'payment_method' ){
            valType = 'text_payment_method';
        } else if(f.rules.cl_field === 'shipping_method' ){
            valType = 'text_shipping_method';
        } else if(f.rules.cl_field === 'shipping_class' ){
            valType = 'text_shipping_class';
        } else if(f.rules.cl_field === 'cart_contains' || f.rules.cl_field === 'cart_not_contains' || f.rules.cl_field === 'cart_only_contains'){
            if( f.rules.cl_relation === 'is_cart_product'){
                valType = 'product_list';
            } else if( f.rules.cl_relation === 'is_cart_category' ){
                valType = 'category_list';
            }
        } else if(f.rules.cl_field === 'cart_product' ){
                valType = 'product_list';

        } else if(f.rules.cl_field === 'cart_category' ){
                valType = 'category_list';

        } else {

            if( f.rules.cl_relation === 'day_is' || f.rules.cl_relation === 'day_is_not' ){
                valType = 'day';
            } else {
                valType = Object.keys(cl_val_type.field).find(e => {
                    return cl_val_type.field[e].includes(selectedField.type);
                })
            }
            /*
            valType = Object.keys(cl_val_type.field).find(e => {
                return cl_val_type.field[e].includes(selectedField.type);
            })
            */

        }


    }

    switch (valType) {
        case 'text':
            return (<input
                name="cl_val"
                className={className}
                type="text"
                value={value}
                onChange={event => {
                    onChange({value: event.target.value});
                }}
            />);
        case 'text_variation':
            return (
            <div>
              <input
                name="cl_val"
                className={className}
                type="text"
                value={value}
                onChange={event => {
                    onChange({value: event.target.value});
                }}
                placeholder={wp.i18n.__('Variation ID\'s separated by comma')}
            />
          <p style={{display: "inline-block"}}>{wp.i18n.__('*Add Variation ID\'s separated by comma')}</p>
          </div>
        );
        case 'text_payment_method':
            return (<input
                name="cl_val"
                className={className}
                type="text"
                value={value}
                onChange={event => {
                    onChange({value: event.target.value});
                }}
                placeholder={wp.i18n.__('Payment method values separated by comma')}
            />);
        case 'text_shipping_method':
            return (<input
                name="cl_val"
                className={className}
                type="text"
                value={value}
                onChange={event => {
                    onChange({value: event.target.value});
                }}
                placeholder={wp.i18n.__('Shipping method values separated by comma')}
            />);
        case 'text_shipping_class':
            return (<input
                name="cl_val"
                className={className}
                type="text"
                value={value}
                onChange={event => {
                    onChange({value: event.target.value});
                }}
                placeholder={wp.i18n.__('Shipping class id\'s separated by comma')}
            />);
        case 'day':
          const options = day_list.map(e => {
              return {
                  label: e.label,
                  value: e.value
              }
          })

          return (<Select
              className={className}
              value={options.filter(e => e.value === value)}
              options={options}
              name="cl_val"
              onChange={(v) => {
                  onChange(v)
              }}
              placeholder="Select"

          />);
        case 'date':
            return (<input
                name="cl_val"
                className={className}
                type="date"
                value={value}
                onChange={event => {
                    onChange({value: event.target.value});
                }}
            />);
        case 'time':
            return (<input
                name="cl_val"
                className={className}
                type="time"
                value={value}
                onChange={event => {
                    onChange({value: event.target.value});
                }}
            />);
        case 'month':
            return (<input
                name="cl_val"
                className={className}
                type="month"
                value={value}
                onChange={event => {
                    onChange({value: event.target.value});
                }}
            />);
        case 'datetime':
            return (<input
                name="cl_val"
                className={className}
                type="datetime-local"
                value={value}
                onChange={event => {
                    onChange({value: event.target.value});
                }}
            />);
            case 'week':
                return (<input
                    name="cl_val"
                    className={className}
                    type="week"
                    value={value}
                    onChange={event => {
                        onChange({value: event.target.value});
                    }}
                />);
            case 'select': {
                // const options = selectedField.values.map(e => {
                const options = selectedField.options.map(e => {
                    return {
                        label: e.label,
                        value: e.value
                    }
                })

            return (<Select
                className={className}
                value={options.filter(e => e.value === value)}
                options={options}
                name="cl_val"
                onChange={(v) => {
                    onChange(v)
                }}
                placeholder="Select"

            />);
        }

        case 'user_role': {
            const options2 = user_roles.map(e => {
                return {
                    // text: e.text,
                    label: e.text,
                    value: e.value,
                    markup: multiSelectOptionMarkup(e.text)
                }
            });

            return (<ReactSelect
                className={className}
                value={options2.filter(e=>value.includes(e.value))}
                options={options2}
                name="cl_val"
                onChange={(v) => {

                    if (v != null && v.length ) {
                        const nextFormValue = v.map(e=>e.value);
                        onChange({value:nextFormValue})
                    } else {
                        onChange({value:[]})
                    }

                }}
                placeholder="Select"
                isMulti
            />);

            /*
            return (<ReactResponsiveSelect
                name="cl_val"
                className={className}
                options={options2}
                noSelectionLabel="Select"
                selectedValues={options2.filter(e=>value.includes(e.value)).map(e=>e.value)}
                multiselect
                caretIcon={caretIcon}
               onChange={newValue => {
                    const { options,altered} = newValue;
                    if (options.length && altered ) {
                        const name = options[0].name;
                        const nextFormValue = options.map(e=>e.value);
                        onChange({value:nextFormValue})
                    }
                }}
            />);
            */

        }

        case 'product_list': {
            const options3 = product_list.map(e => {
                return {
                     // text: e.text,
                    label: e.text,
                    value: e.value,
                    markup: multiSelectOptionMarkup(e.text)
                }
            });

            return (
              <div>
            { /*
              <ReactSelect
                className={className}
                value={options3.filter(e=>value.includes(e.value))}
                options={options3}
                name="cl_val"
                onChange={(v) => {

                    if (v != null && v.length ) {
                        const nextFormValue = v.map(e=>e.value);
                        onChange({value:nextFormValue})
                    } else {
                        onChange({value:[]})
                    }

                }}
                placeholder="Select"
                isMulti
            />
          */ }

            <AsyncSelect
              value={options3.filter(e=>value.includes(e.value))}
              name="cl_val"
              isMulti={true}
              isSearchable={true}
              placeholder={wp.i18n.__('Type to Select Products')}
              noOptionsMessage={() => wp.i18n.__('No products found. Start typing.')}
              onChange={(v) => {

                  if (v != null && v.length ) {
                      const nextFormValue = v.map(e=>e.value);
                      onChange({value:nextFormValue})
                  } else {
                      onChange({value:[]})
                  }

              }}
              loadOptions={loadProdOptions}
              className={className}
            />
            <p style={{display: "inline-block"}}>{wp.i18n.__('*Start typing to select the product from the list.')}</p>
        </div>
            );

            /*
            return (<ReactResponsiveSelect
                name="cl_val"
                className={className}
                options={options3}
                noSelectionLabel="Select"
                selectedValues={options3.filter(e=>value.includes(e.value)).map(e=>e.value)}
                multiselect
                caretIcon={caretIcon}
                 onChange={newValue => {
                    const { options,altered} = newValue;
                    if (options.length && altered ) {
                        const name = options[0].name;
                        const nextFormValue = options.map(e=>e.value);
                        onChange({value:nextFormValue})
                    }
                }}
            />);
            */


        }

        case 'category_list': {
            const options4 = category_list.map(e => {
                return {
                    // text: e.text,
                    label: e.text,
                    value: e.value,
                    markup: multiSelectOptionMarkup(e.text)
                }
            });

            return (<ReactSelect
                className={className}
                value={options4.filter(e=>value.includes(e.value))}
                options={options4}
                name="cl_val"
                onChange={(v) => {

                    if (v != null && v.length ) {
                        const nextFormValue = v.map(e=>e.value);
                        onChange({value:nextFormValue})
                    } else {
                        onChange({value:[]})
                    }

                }}
                placeholder="Select"
                isMulti
            />);

        }

        default:
            return null;

    }

}
const mapStateToProps = (state) => {


    let ReduxFields = {fields: []};
    if (typeof  state.fields.data !== "undefined") {
        ReduxFields = state.fields.data;
    }
    return {
        ReduxFields,
        version: typeof state.fields.version !== "undefined" ? state.fields.version : 0
    }
}
export default connect(mapStateToProps)(RenderConditionalLogic)


//
// class RenderConditionalLogic extends React.Component() {
//     constructor(props) {
//         super(props);
//         const forms = [];
//         this.state = {
//             data: props.rules,
//             type: props.type
//         };
//     }
//
//     render() {
//         return (
//             <div>
//                 <div style={{width: '150px'}}>
//                     <label>Logic Action</label>
//                     <Select
//                         options={[{value: "show", label: "Show"}, {value: "hide", label: "Hide"}]}
//                     />
//                 </div>
//                 <div>
//                     <div className="groups">
//                         <div className="group">
//                             <div className="rules">
//                                 <div className="rule">
//                                     <div className="fields"/>
//                                 </div>
//                             </div>
//                         </div>
//
//                     </div>
//                 </div>
//             </div>
//         )
//     }
//
// }
//
// export default RenderConditionalLogic;
